var list = [];
for (var i = 2019; i >= 1900; i--) {
  list.push({ value: i, label: i });
}

var oneToTen = [];
for (var j = 1; j <= 10; j++) {
  oneToTen.push({ value: j, label: j });
}

const options = {
  // selectedRegisteredPatient: [
  //   {
  //     value:
  //       "Username: charlie : full name (charlie chaplin) Day of Birth: 1970-12-21male",
  //     label:
  //       "Username: charlie : full name (charlie chaplin) Day of Birth: 1970-12-21male",
  //   },
  // ],
  currentTreatment: [
    { value: "Ayurveda", label: "Ayurveda" },
    {
      value: "Traditional Chinese Medicine",
      label: "Traditional Chinese Medicine",
    },
    { value: "regular/conventional", label: "regular/conventional" },
    { value: "naturopratic", label: "naturopratic" },
    { value: "osteopathic", label: "osteopathic" },
    { value: "shiatsu", label: "shiatsu" },
    { value: "bach-flowers", label: "bach-flowers" },
    { value: "tuina", label: "tuina" },
    { value: "reiki", label: "reiki" },
    { value: "other", label: "other" },
  ],
  familyMember: [
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Grandpa at Father's side", label: "Grandpa at Father's side" },
    { value: "Grandma at Father's side", label: "Grandma at Father's side" },
    { value: "Grandpa at Mother's side", label: "Grandpa at Mother's side" },
    { value: "Grandma at Mother's side", label: "Grandma at Mother's side" },
    { value: "Uncle at Father's side", label: "Uncle at Father's side" },
    { value: "Uncle at Mother's side", label: "Uncle at Mother's side" },
    { value: "Aunt at Father's side", label: "Aunt at Father's side" },
    { value: "Aunt at Mother's side", label: "Aunt at Mother's side" },
    { value: "Cousin at Father's side", label: "Cousin at Father's side" },
    { value: "Cousin at Mother's side", label: "Cousin at Mother's side" },
    { value: "Nephew", label: "Nephew" },
    { value: "Niece", label: "Niece" },
    {
      value: "Granduncle at Father's side",
      label: "Granduncle at Father's side",
    },
    {
      value: "Granduncle at Mother's side",
      label: "Granduncle at Mother's side",
    },
    {
      value: "Grandaunt at Father's side",
      label: "Grandaunt at Father's side",
    },
    {
      value: "Grandaunt at Mother's side",
      label: "Grandaunt at Mother's side",
    },
  ],
  year: list,
  state: [
    {
      value: "Cured",
      label: "Cured",
    },
    {
      value: "In Treatment",
      label: "In Treatment",
    },
    {
      value: "Died",
      label: "Died",
    },
    {
      value: "Other",
      label: "Other",
    },
  ],
  socialRelationship: [
    {
      value: "Single",
      label: "Single",
    },
    {
      value: "Divorced",
      label: "Divorced",
    },
    {
      value: "Widowed",
      label: "Widowed",
    },
    {
      value: "Married",
      label: "Married",
    },
    {
      value: "In relationship",
      label: "In relationship",
    },
    {
      value: "Legally separated",
      label: "Legally separated",
    },
  ],
  habits: [
    {
      value: "smoking",
      label: "smoking",
    },
    {
      value: "alcohol",
      label: "alcohol",
    },
    {
      value: "coffee",
      label: "coffee",
    },
    {
      value: "tea",
      label: "tea",
    },
    {
      value: "heroin",
      label: "heroin",
    },
    {
      value: "sugar",
      label: "sugar",
    },
    {
      value: "cocaine",
      label: "cocaine",
    },
    {
      value: "marijuana",
      label: "marijuana",
    },
  ],
  employmentStatus: [
    {
      value: "full-time",
      label: "full-time",
    },
    {
      value: "part-time",
      label: "part-time",
    },
    {
      value: "freelance",
      label: "freelance",
    },
    {
      value: "retired",
      label: "retired",
    },
    {
      value: "unemployed",
      label: "unemployed",
    },
  ],
  sportFrequency: [
    {
      value: "never",
      label: "never",
    },
    {
      value: "rare",
      label: "rare",
    },
    {
      value: "sometimes",
      label: "sometimes",
    },
    {
      value: "regular",
      label: "regular",
    },
    {
      value: "very regular",
      label: "very regular",
    },
  ],
  bmiClassification: [
    {
      value: "Underweight",
      label: "Underweight",
    },
    {
      value: "Normal weight",
      label: "Normal weight",
    },
    {
      value: "Overweight",
      label: "Overweight",
    },
    {
      value: "Obesity",
      label: "Obesity",
    },
  ],
  thermalFeeling: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "chilly",
      label: "chilly",
    },
    {
      value: "hot flush",
      label: "hot flush",
    },
    {
      value: "feverish",
      label: "feverish",
    },
    {
      value: "night sweating",
      label: "night sweating",
    },
  ],
  perspiration: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "frequent",
      label: "frequent",
    },
    {
      value: "absent",
      label: "absent",
    },
    {
      value: "profuse",
      label: "profuse",
    },
    {
      value: "night sweating",
      label: "night sweating",
    },
  ],
  appetite: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "excess",
      label: "excess",
    },
    {
      value: "poor",
      label: "poor",
    },
    {
      value: "craving",
      label: "craving",
    },
  ],
  vomiting: [
    {
      value: "no",
      label: "no",
    },
    {
      value: "yes",
      label: "yes",
    },
    {
      value: "yes with blood",
      label: "yes with blood",
    },
  ],
  diet: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "vegeterian",
      label: "vegeterian",
    },
    {
      value: "meat",
      label: "meat",
    },
    {
      value: "seafood",
      label: "seafood",
    },
    {
      value: "Bionic",
      label: "Bionic",
    },
  ],
  taste: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "bitter",
      label: "bitter",
    },
    {
      value: "greasy",
      label: "greasy",
    },
    {
      value: "bland",
      label: "bland",
    },
    {
      value: "acrid/pungent",
      label: "acrid/pungent",
    },
  ],
  thirst: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "excess",
      label: "excess",
    },
    {
      value: "little",
      label: "little",
    },
    {
      value: "cold",
      label: "cold",
    },
    {
      value: "hot",
      label: "hot",
    },
  ],
  defecation: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "diarrhea",
      label: "diarrhea",
    },
    {
      value: "constipated",
      label: "constipated",
    },
    {
      value: "loose",
      label: "loose",
    },
    {
      value: "dry",
      label: "dry",
    },
  ],
  urination: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "scanty",
      label: "scanty",
    },
    {
      value: "difficult",
      label: "difficult",
    },
    {
      value: "painful",
      label: "painful",
    },
    {
      value: "frequent",
      label: "frequent",
    },
    {
      value: "frequent in the night",
      label: "frequent in the night",
    },
    {
      value: "sometimes",
      label: "sometimes",
    },
  ],
  urinationColor: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "yellow",
      label: "yellow",
    },
    {
      value: "dark yellow",
      label: "dark yellow",
    },
    {
      value: "bloody",
      label: "bloody",
    },
    {
      value: "white",
      label: "white",
    },
  ],
  sleep: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "heavy",
      label: "heavy",
    },
    {
      value: "poor",
      label: "poor",
    },
    {
      value: "restlesness",
      label: "restlesness",
    },
    {
      value: "dreamed",
      label: "dreamed",
    },
  ],
  head: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "dizzy",
      label: "dizzy",
    },
    {
      value: "drowsy",
      label: "drowsy",
    },
    {
      value: "headache",
      label: "headache",
    },
  ],
  eyes: [
    {
      value: "Normal",
      label: "Normal",
    },
    {
      value: "Blurry vision",
      label: "Blurry vision",
    },
    {
      value: "Dry",
      label: "Dry",
    },
    {
      value: "Tearing",
      label: "Tearing",
    },
    {
      value: "Continent",
      label: "Continent",
    },
    {
      value: "Red",
      label: "Red",
    },
    {
      value: "Yellow",
      label: "Yellow",
    },
    {
      value: "Lazy",
      label: "Lazy",
    },
    {
      value: "Colorblindness",
      label: "Colorblindness",
    },
    {
      value: "Lightsensitivity",
      label: "Lightsensitivity",
    },
    {
      value: "Floaters",
      label: "Floaters",
    },
    {
      value: "Discharge",
      label: "Discharge",
    },
    {
      value: "Pink",
      label: "Pink",
    },
    {
      value: "Watery",
      label: "Watery",
    },
  ],
  ear: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "ear ringing",
      label: "ear ringing",
    },
    {
      value: "poor hearing",
      label: "poor hearing",
    },
    {
      value: "pain",
      label: "pain",
    },
    {
      value: "discharge",
      label: "discharge",
    },
  ],
  nose: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "dry",
      label: "dry",
    },
    {
      value: "runny nose",
      label: "runny nose",
    },
    {
      value: "blocked sensation",
      label: "blocked sensation",
    },
    {
      value: "nasal stuffiness",
      label: "nasal stuffiness",
    },
    {
      value: "nasal congestion",
      label: "nasal congestion",
    },
    {
      value: "reduced sense of smell",
      label: "reduced sense of smell",
    },
    {
      value: "snoring",
      label: "snoring",
    },
    {
      value: "runny nose",
      label: "runny nose",
    },
    {
      value: "bleeding",
      label: "bleeding",
    },
    {
      value: "postnasal drip",
      label: "postnasal drip",
    },
    {
      value: "breathing through your mouth",
      label: "breathing through your mouth",
    },
    {
      value: "a feeling of pressure in your forehead or face",
      label: "a feeling of pressure in your forehead or face",
    },
  ],
  throat: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "dry",
      label: "dry",
    },
    {
      value: "sore",
      label: "sore",
    },
    {
      value: "difficulty swallow",
      label: "difficulty swallow",
    },
    {
      value: "swollen",
      label: "swollen",
    },
  ],
  menstruation: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "absent",
      label: "absent",
    },
    {
      value: "iregular",
      label: "iregular",
    },
    {
      value: "use of birth-control-pill",
      label: "use of birth-control-pill",
    },
  ],
  leukorrea: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "thick",
      label: "thick",
    },
    {
      value: "watery",
      label: "watery",
    },
    {
      value: "profuse",
      label: "profuse",
    },
    {
      value: "yellowish",
      label: "yellowish",
    },
    {
      value: "clear",
      label: "clear",
    },
    {
      value: "odor",
      label: "odor",
    },
  ],
  natureOfPain: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "distending",
      label: "distending",
    },
    {
      value: "sharp pricking like needle",
      label: "sharp pricking like needle",
    },
    {
      value: "dull",
      label: "dull",
    },
    {
      value: "hollow",
      label: "hollow",
    },
    {
      value: "fixed",
      label: "fixed",
    },
    {
      value: "movable",
      label: "movable",
    },
    {
      value: "lumb/numbness",
      label: "lumb/numbness",
    },
    {
      value: "nodule",
      label: "nodule",
    },
    {
      value: "dislike pressure",
      label: "dislike pressure",
    },
    {
      value: "prefer cold",
      label: "prefer cold",
    },
    {
      value: "prefer hot",
      label: "prefer hot",
    },
    {
      value: "radiating",
      label: "radiating",
    },
    {
      value: "weighty",
      label: "weighty",
    },
    {
      value: "colickly",
      label: "colickly",
    },
    {
      value: "burning",
      label: "burning",
    },
  ],
  emotionNote: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "unhappy/sad",
      label: "unhappy/sad",
    },
    {
      value: "happy",
      label: "happy",
    },
    {
      value: "stressed",
      label: "stressed",
    },
    {
      value: "depressed",
      label: "depressed",
    },
    {
      value: "lonely",
      label: "lonely",
    },
    {
      value: "melancholy",
      label: "melancholy",
    },
    {
      value: "angry",
      label: "angry",
    },
  ],
  respiration: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "lower",
      label: "lower",
    },
    {
      value: "heavy feeble",
      label: "heavy feeble",
    },
  ],
  speech: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "shallow",
      label: "shallow",
    },
    {
      value: "louder",
      label: "louder",
    },
    {
      value: "feeble",
      label: "feeble",
    },
  ],
  cough: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "coarse",
      label: "coarse",
    },
    {
      value: "feeble",
      label: "feeble",
    },
    {
      value: "spurum",
      label: "spurum",
    },
    {
      value: "dry",
      label: "dry",
    },
  ],
  odor: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "stinky",
      label: "stinky",
    },
    {
      value: "foul",
      label: "foul",
    },
    {
      value: "sour",
      label: "sour",
    },
  ],
  vitality: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "dispirited",
      label: "dispirited",
    },
    {
      value: "hyperactive depressed",
      label: "hyperactive depressed",
    },
    {
      value: "anxious",
      label: "anxious",
    },
    {
      value: "stressed",
      label: "stressed",
    },
  ],
  appearance: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "heavy",
      label: "heavy",
    },
    {
      value: "fat",
      label: "fat",
    },
    {
      value: "medium",
      label: "medium",
    },
    {
      value: "slim",
      label: "slim",
    },
    {
      value: "strong",
      label: "strong",
    },
    {
      value: "weak",
      label: "weak",
    },
  ],
  colorFace: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "pale",
      label: "pale",
    },
    {
      value: "yellow",
      label: "yellow",
    },
    {
      value: "red",
      label: "red",
    },
    {
      value: "blue",
      label: "blue",
    },
    {
      value: "dark-gray",
      label: "dark-gray",
    },
  ],
  emotionState: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "unhappy/sad",
      label: "unhappy/sad",
    },
    {
      value: "happy",
      label: "happy",
    },
    {
      value: "stressed",
      label: "stressed",
    },
    {
      value: "depressed",
      label: "depressed",
    },
    {
      value: "lonely",
      label: "lonely",
    },
    {
      value: "melancholy",
      label: "melancholy",
    },
    {
      value: "angry",
      label: "angry",
    },
  ],
  
  physicalAppearance: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "discoloration",
      label: "discoloration",
    },
    {
      value: "swelling",
      label: "swelling",
    },
    {
      value: "edema",
      label: "edema",
    },
    {
      value: "atrophy",
      label: "atrophy",
    },
  ],
  epigastriumPalpation: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "hard",
      label: "hard",
    },
    {
      value: "soft",
      label: "soft",
    },
  ],
  abdomenPalpation: [
    {
      value: "normal",
      label: "normal",
    },
    {
      value: "distension and fullness",
      label: "distension and fullness",
    },
    {
      value: "fullness like a rubber bag",
      label: "fullness like a rubber bag",
    },
  ],
  rangeMotion: [
    {
      value: "cervical",
      label: "cervical",
    },
    {
      value: "lumbar",
      label: "lumbar",
    },
    {
      value: "shoulder",
      label: "shoulder",
    },
    {
      value: "elbow",
      label: "elbow",
    },
    {
      value: "hip",
      label: "hip",
    },
  ],
  painLevel: oneToTen,
  potency: [
    {
      value: "none",
      label: "none",
    },
    {
      value: "1",
      label: "1",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3",
      label: "3",
    },
    {
      value: "4",
      label: "4",
    },
    {
      value: "5",
      label: "5",
    },
    {
      value: "6",
      label: "6",
    },
    {
      value: "7",
      label: "7",
    },
    {
      value: "8",
      label: "8",
    },
    {
      value: "9",
      label: "9",
    },
    {
      value: "10",
      label: "10",
    },
  ],
  gender: [
    {
      value: "Male", label: "Male" 
    },
    {
      value: "Female", label: "Female"
    },
    {
      value: "Transgender", label: "Transgender"
    },
  ],

  tongueShape: [
    {
      value: "cracks", label: "cracks",
    },
    {
      value: "tooth-marks", label: "tooth-marks around the tongue",
    },
    {
      value: "swollen", label: "swollen",
    },
    {
      value: "dropping-in-heart-tongue", label: "Dropping, scooping in heart of tongue",
    },
  ],

  tongueColor: [
    {
      value: "pale", label: "pale",
    },
    {
      value: "red", label: "red",
    },
    {
      value: "black", label: "black",
    },
  ],

  pulseType: [
    {
      value: "vata", label: "Vata (Wind)",
    },
    {
      value: "pitta", label: "Pitta (Fire)",
    },
    {
      value: "kapha", label: "Kapha (Water)",
    },

  ],

  pulseRate: [
    {
      value: "quick-higherthan80", label: "Quick (>80)",
    },
    {
      value: "moderate (70-80)", label: "Moderate (70-80)",
    },
    {
      value: "slow (50-60)", label: "Slow (50-60)",
    },

  ],

  pulseRhythm: [
    {
      value: "irregular", label: "Irregular",
    },
    {
      value: "relatively-regular", label: "Relatively regular",
    },
    {
      value: "very-regular", label: "Very regular",
    },

  ],

  pulseIntensity: [
    {
      value: "variable", label: "Variable",
    },
    {
      value: "strong", label: "Strong",
    },
    {
      value: "weak", label: "Weak",
    },

  ],

  pulseVolume: [
    {
      value: "low", label: "Low",
    },
    {
      value: "medium", label: "Medium",
    },
    {
      value: "high", label: "High",
    },

  ],

  pulseQuality: [
    {
      value: "hot", label: "Hot",
    },
    {
      value: "cold", label: "Cold",
    },
    {
      value: "heavy", label: "Heavy",
    },
    {
      value: "light", label: "Light",
    },
    {
      value: "slow", label: "Slow",
    },
    {
      value: "quick", label: "Quick",
    },
    {
      value: "dry", label: "Dry",
    },
    {
      value: "oily", label: "Oily",
    },
    {
      value: "hard", label: "Hard",
    },
    {
      value: "soft", label: "Soft",
    },
    {
      value: "stable", label: "Stable",
    },
    {
      value: "moving", label: "Moving",
    },
    {
      value: "clear", label: "Clear",
    },
    {
      value: "faint", label: "Faint",
    },
    {
      value: "subtle", label: "Subtle",
    },
    {
      value: "strong", label: "Strong",
    },
    {
      value: "thin", label: "Thin",
    },
    {
      value: "viscous", label: "Viscous",
    },
    {
      value: "rough", label: "Rough",
    },
    {
      value: "smooth", label: "Smooth",
    },

  ],

  mindConstitution: [
    {
      value: "sattva", label: "Sattva (peace, tolerance and harmony)",
    },
    {
      value: "tamasa", label: "Tamasa (ambition, spontaneity and passion)",
    },
    {
      value: "rajasa", label: "Rajasa (sloth, inertia and ignorance)",
    },
    {
      value: "vata", label: "Vata Dosha (Wind energy)",
    },
    {
      value: "pitta", label: "Pitta Dosha (Fire energy)",
    },
    {
      value: "kapha", label: "Kapha Dosha (Water energy)",
    },
  ],

  aBodyConstitution: [
    {
      value: "vata", label: "Vata Dosha (Wind energy)",
    },
    {
      value: "pitta", label: "Pitta Dosha (Fire energy)",
    },
    {
      value: "kapha", label: "Kapha Dosha (Water energy)",
    },

  ],

  diseaseFormation: [
    {
      value: "sanchaya", label: "Sanchaya(Accumulation)",
    },
    {
      value: "prakopa", label: "Prakopa(Aggravation)",
    },
    {
      value: "Prasara", label: "Prasara(Spread)",
    },
    {
      value: "sthana-samshraya", label: "Sthana Samshraya(Localisation)",
    },
    {
      value: "vyakti", label: "Vyakti(Manifestation)",
    },
    {
      value: "bheda", label: "Bheda(Outbreak)",
    },
  ],

  principleTreatment: [
    {
      value: "Abhyangam", label: "Abhyangam",
    },
    {
      value: "Shirodhara", label: "Shirodhara",
    },
    {
      value: "Kashayadhara", label: "Kashayadhara",
    },
    {
      value: "Greeva Basti", label: "Greeva Basti",
    },
    {
      value: "Janu Basti", label: "Janu Basti",
    },
    {
      value: "Kati Basti", label: "Kati Basti",
    },
    {
      value: "Spine Basti", label: "Spine Basti",
    },	
    {
      value: "Kizhi", label: "Kizhi",
    },
    {
      value: "Mukha Lepam", label: "Mukha Lepam",
    },
    {
      value: "Netra Tarpanam", label: "Netra Tarpanam",
    },
    {
      value: "Padabhyangam", label: "Padabhyangam",
    },
    {
      value: "Pizhichil", label: "Pizhichil",
    },	
    {
      value: "Shringara", label: "Shringara",
    },
    {
      value: "Soundarya", label: "Soundarya",
    },
    {
      value: "Thalapothichil", label: "Thalapothichil",
    },
    {
      value: "Ubtan", label: "Ubtan",
    },
    {
      value: "Udvartanam", label: "Udvartanam",
    },
    {
      value: "Vamanan", label: "Vamanan",
    },
    {
      value: "Virechanam", label: "Virechanam",
    },	
    {
      value: "Snehavasthy", label: "Snehavasthy",
    },	
    {
      value: "Nasyam", label: "Nasyam",
    },	
    {
      value: "Kashayavasthy", label: "Kashayavasthy",
    },
    {
      value: "Uzhichil", label: "Uzhichil/Abhyanga",
    },
    {
      value: "Tharpanam", label: "Tharpanam",
    },
    {
      value: "Putapakam", label: "Putapakam",
    },	
    {
      value: "Pichu", label: "Pichu",
    },	
    {
      value: "Pizhichil", label: "Pizhichil",
    },	
    {
      value: "Pizhichil", label: "Pizhichil",
    },
    {
      value: "Podikizhy", label: "Podikizhy",
    },	
    {
      value: "Dhanyamladhara", label: "Dhanyamladhara",
    },	
    {
      value: "Kateevasthy", label: "Kateevasthy",
    },		
    {
      value: "Upanaham", label: "Upanaham",
    },	
    {
      value: "Thalam", label: "Thalam",
    },		
    {
      value: "Rakthamoksham", label: "Rakthamoksham",
    },
    {
      value: "Udwarthanam", label: "Udwarthanam",
    },		
    {
      value: "Ksheera Dhoomam", label: "Ksheera Dhoomam",
    },		
    {
      value: "Ksheeradhara", label: "Ksheeradhara",
    },	
    {
      value: "Avagaham", label: "Avagaham",
    },		
    {
      value: "Navarakizhi", label: "Navarakizhi",
    },		
    {
      value: "Narangakizhi", label: "Narangakizhi",
    },		
	
  ],

  remedy: [
    {
      value: "Abies Canadensis",
      label: "Abies Canadensis",
    },
    {
      value: "Abies Nigra",
      label: "Abies Nigra",
    },
    {
      value: "Acalypha Indica",
      label: "Acalypha Indica",
    },
    {
      value: "Acetic Acid",
      label: "Acetic Acid",
    },
    {
      value: "Aconitum Napellus",
      label: "Aconitum Napellus",
    },
  ],
  unit:[
    {value: 'gr', label: 'Gram'},
    {value: 'pieces', label: 'Pieces'},
  ],
  
};

export default options;
